import Image from 'next/image';
import Link from 'next/link';
import { CornerArrow } from '../components/sub-page-sections';

export function FaqClosingCta({ locale }: { locale: string }) {
  return (
    <section className="faq-closing" aria-labelledby="faq-closing-heading">
      <Image
        src="/landing/assets/images/shipsmart/industry/redesign/blue-fleet-night-wide.webp"
        alt=""
        fill
        sizes="100vw"
        className="faq-closing-photo"
      />
      <div className="mx-auto w-[90%] max-w-[1440px]">
        <div className="faq-closing-content">
          <span className="faq-closing-label">
            <span aria-hidden="true" />
            Closing CTA
          </span>
          <h2 id="faq-closing-heading">
            Keep Your Food
            <br />
            Freight in Spec
          </h2>
          <p>
            Get food-grade reefer capacity, verified cold-chain control, and one
            accountable team.
          </p>
          <div className="faq-closing-actions">
            <Link
              href={`/${locale}/get-quote`}
              className="faq-closing-link faq-closing-link-primary"
            >
              Get a Food &amp; Beverage Quote <CornerArrow />
            </Link>
            <Link
              href={`/${locale}/services/reefer`}
              className="faq-closing-link"
            >
              Explore Reefer Trucking <CornerArrow />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
